export default __webpack_public_path__ + "static/media/icon_tenant.a63bbcc1.png";